import React from 'react';
import { InfoIcon } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface CumulativeVariancesHeaderProps {
  tooltipText: string;
  label?: string;
}

/**
 * Component for cumulative variances header with tooltip
 */
export const CumulativeVariancesHeader: React.FC<CumulativeVariancesHeaderProps> = ({
  tooltipText,
  label = 'Cumulative Variances',
}) => {
  return (
    <div className="!cursor-default flex items-center gap-1 group">
      <span>{label}</span>
      {tooltipText && (
        <Tooltip>
          <TooltipTrigger>
            <InfoIcon className="w-4 h-4 text-gray-400 group-hover:text-gray-700" />
          </TooltipTrigger>
          <TooltipContent className="bg-white text-black">
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};
